/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * アンケートの提示到達（到達→完了ファネルの土台・ADR-0015）。
 */
export interface SurveyImpressionInput {
  /** 提示したノード（動画ノード or SURVEYノード） */
  nodeKey: string
  /** 視聴セッションID（クライアント生成） */
  sessionId: string
}
